import type {
  PolicyFieldDescriptor,
  PolicyFieldValue,
  TenantCommercialPolicy,
  VerticalPolicyView,
} from '@/lib/api/botSettings'
import PolicyField from './PolicyField'
import { readTenantValue, writeSectionValue } from './policyFormUtils'

interface PolicySectionFormProps {
  view: VerticalPolicyView
  policy: TenantCommercialPolicy | null
  onChange: (updated: TenantCommercialPolicy) => void
  /** Qué grupo de campos pintar; el panel separa condiciones comerciales de logística. */
  group: PolicyFieldDescriptor['group']
}

export default function PolicySectionForm({ view, policy, onChange, group }: PolicySectionFormProps) {
  const fields = view.descriptors.filter((descriptor) => descriptor.group === group)
  if (fields.length === 0) return null

  const handleChange = (key: string, value: PolicyFieldValue | null) =>
    onChange(writeSectionValue(policy, view.section, key, value))

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {fields.map((descriptor) => (
        <div key={descriptor.key} className={descriptor.type === 'tags' ? 'md:col-span-2' : undefined}>
          <PolicyField
            descriptor={descriptor}
            value={readTenantValue(policy, view.section, descriptor)}
            effective={view.effective[descriptor.key]}
            onChange={(value) => handleChange(descriptor.key, value)}
          />
        </div>
      ))}
    </div>
  )
}
